import { render } from "./AuthRegister.vue?vue&type=template&id=39e55c3c&scoped=true"
import script from "./AuthRegister.vue?vue&type=script&lang=ts"
export * from "./AuthRegister.vue?vue&type=script&lang=ts"

import "./AuthRegister.vue?vue&type=style&index=0&id=39e55c3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39e55c3c"

export default script